module.exports = __webpack_public_path__ + "img/1577467066.7fc3a903.jpg";